/* eslint-disable @typescript-eslint/no-explicit-any */
import { TFunction } from 'i18next'
import isEmpty from 'lodash/isEmpty'
import keyBy from 'lodash/keyBy'
import merge from 'lodash/merge'
import values from 'lodash/values'
import { IProgram } from '../interfaces'

export const mergeByKey = function (array1: any[], array2: any[], key: string) {
  const mergedObject = merge(keyBy(array1, key), keyBy(array2, key))
  return values(mergedObject)
}

export const getSubdomainFromUrl = function (url: string) {
  const hostname = new URL(url).hostname
  const hostnameParts = hostname.split('.')
  const subdomain = hostnameParts[0]

  return subdomain
}

export const getCurrentDateString = function (date: Date, time: string) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${time}`
}

export const parseCustomDateString = function (dateString: string): Date | null {
  const regex = /(\d{4})-(\d{1,2})-(\d{1,2})\s(\d{1,2}:\d{1,2})(\w{2})/
  const matchResult = dateString.match(regex)

  if (!matchResult) {
    return null
  }

  const [, year, month, day, time, period] = matchResult
  const [hours, minutes] = time.split(':').map(Number)
  const adjustedHours =
    period.toLowerCase() === 'pm' && hours !== 12
      ? hours + 12
      : period.toLowerCase() === 'am' && hours === 12
      ? 0
      : hours

  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), adjustedHours, minutes)
}

export const getOpenClosed = function (
  program: IProgram,
  t: TFunction<'translation', undefined, 'translation'>,
) {
  if (isEmpty(program.operatingHours)) {
    return t('filters.callForHours')
  }

  const dateTime = new Date()
  const dateTimeInLA = new Date(
    dateTime.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }),
  )

  const dayOfWeek = dateTimeInLA.getDay() + 1

  const operatingHour = program.operatingHours.find((oh) => oh.dayOfWeekId === dayOfWeek)

  if (!operatingHour) return t('filters.callForHours')

  const isUnknown = operatingHour.open === '' && operatingHour.close === ''

  if (!isUnknown && !operatingHour.isClosed) {
    if (operatingHour.open === '12:00am') {
      return t('filters.open')
    }

    const openTime = parseCustomDateString(getCurrentDateString(dateTimeInLA, operatingHour.open))

    const closedTime = parseCustomDateString(
      getCurrentDateString(dateTimeInLA, operatingHour.close),
    )

    if (openTime && closedTime) {
      if (openTime <= dateTimeInLA && dateTimeInLA < closedTime) {
        return t('filters.open')
      }
    }
  } else {
    if (operatingHour.open === '' && operatingHour.close === '') {
      return t('filters.callForHours')
    }
  }
  return t('filters.closed')
}
